import PartnersOrResellersContainer from './partners-and-resellers.container';

export default PartnersOrResellersContainer;
